import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f27f9f44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bookmark"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-bookmark" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [..._hoisted_3]))
    : _createCommentVNode("v-if", true)
}